import { Injectable } from '@angular/core';
import { CurrentUserMapper } from '@common/mappers/current-user.mapper';
import { CurrentUserVm } from '@common/models/current-user/current-user.vm';
import { CurrentUserService } from '@core/services/current-user.service';
import { map, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IdentityFacade {
  constructor(private currentUserService: CurrentUserService) {}

  getCurrentUser(force = false): Observable<CurrentUserVm | null> {
    return this.currentUserService
      .getMe(force)
      .pipe(
        map((dto) => (dto ? CurrentUserMapper.mapResponseToVm(dto) : null)),
      );
  }

  getSnapshot(): CurrentUserVm | null {
    const dto = this.currentUserService.getSnapshot();
    return dto ? CurrentUserMapper.mapResponseToVm(dto) : null;
  }

  clear(): void {
    this.currentUserService.clear();
  }
}
